import { render, staticRenderFns } from "./jumbo.vue?vue&type=template&id=77bfbed7&scoped=true"
import script from "./jumbo.vue?vue&type=script&lang=js"
export * from "./jumbo.vue?vue&type=script&lang=js"
import style0 from "./jumbo.vue?vue&type=style&index=0&id=77bfbed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bfbed7",
  null
  
)

export default component.exports